import React, { FC } from 'react';
import cx from 'classnames';
import { CardLinkProps } from '@/helpers/CardControls/typings';
import { Link } from '@/helpers/Link/render';
import useThemeBlock from '@/hooks/useThemeBlock';
import { Image } from '@/components/molecules/Image/render';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type CardAddressProps = ThemeProps & {
	image: ImageProps;
	title: string;
	text: string;
	link?: CardLinkProps;
};

/**
 * COMPONENT
 */
export const CardAddress: FC<CardAddressProps> & BlockConfigs = ({
	image,
	title,
	text,
	link: { href = null, opensInNewTab = false, ...linkProps } = {},
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx(
		'supt-card supt-cardAddress',
		getStyles(blockTheme),
		href && 'supt-withLink'
	);

	return (
		<div className={rootClass} data-block={block.slug} {...htmlProps}>
			{href ? (
				<Link
					href={href}
					{...(opensInNewTab && {
						target: '_blank',
						rel: 'noopener noreferrer',
					})}
					className="supt-cardAddress__image"
					{...linkProps}
				>
					<Image {...image} />
				</Link>
			) : (
				<Image {...image} className="supt-cardAddress__image" />
			)}
			<div className="supt-cardAddress__wrapperContent">
				<div className="supt-cardAddress__content">
					<h4
						className="supt-cardAddress__title"
						dangerouslySetInnerHTML={{ __html: title }}
					/>
					<p
						className="supt-cardAddress__text"
						dangerouslySetInnerHTML={{ __html: text }}
					/>
				</div>
			</div>
		</div>
	);
};

CardAddress.slug = block.slug;
CardAddress.title = block.title;
